
import { BrowserRouter as Router, Switch, Route,  } from 'react-router-dom';
import Header from './Header/Header';
import BigNav from './Header/BigNav';
import About from './about/About';
import Services from './services/Services';
import Experience from './experience/Experience';
import Projects from './projects/Projects';
import Happy from './happy/Happy';
import Partics from './particles/Partics';
import Particles2 from './particles/Particles2';
import Foot from './foot/Foot';


function App() {
 

  
  return (
    <Router>
      <Switch>
    <div>
     <BigNav/> 
     <Partics/>
     <Particles2/>
     <About/>
     <Services/>
     <Experience/>
     <Projects/>
     <Happy/>
     <Route path="/wasap" component={() => {
         window.location.href = 'https://wa.link/84sadp';
         return null;
       }} >

       </Route>
       <Route path="/facebook" component={() => {
         window.location.href = 'https://web.facebook.com/elijha.kidulani';
         return null;
       }} >

       </Route>

       <Route path="/youtube" component={() => {
         window.location.href = 'https://www.youtube.com/channel/UCiTJRtfb96xEs61QQpTya1Q';
         return null;
       }} >

       </Route>

       <Route path="/instagram" component={() => {
         window.location.href = 'https://www.instagram.com/elijhakidulani/';
         return null;
       }} >

       </Route>

       <Route path="/bitcoin" component={() => {
         window.location.href = 'https://bitcoin-38ac3.web.app';
         return null;
       }} >

       </Route>

       <Route path="/netflix" component={() => {
         window.location.href = 'https://netflix-clone-92105.web.app';
         return null;
       }} >

       </Route>
        
       <Route path="/architect" component={() => {
         window.location.href = 'https://zabinji-f3db9.web.app';
         return null;
       }} >

       </Route>

       <Route path="/amazon" component={() => {
         window.location.href = 'https://e-copy-238aa.web.app';
         return null;
       }} >

       </Route>

       <Route path="/mindzbook" component={() => {
         window.location.href = 'https://mindz-582bb.web.app/';
         return null;
       }} >

          

       </Route>

       <Route path="/mindzmovies" component={() => {
         window.location.href = 'https://mindzmovies-79127.web.app';
         return null;
       }} >

       </Route>
       <Route path="/dalali" component={() => {
         window.location.href = 'https://www.zero-dalali.com';
         return null;
       }} >

       </Route>

     </div>
     </Switch>
     </Router>
  );
}

export default App;
